import type { CoreApiError, UserMeModel } from '@lqa-frontend/api-services';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';
import {
	AUTH_LOCAL_STORAGE_KEY,
	coreApiClient,
	coreApiQueryKey,
	endpoints,
} from '@lqa-frontend/api-services';
import { useQuery } from '@tanstack/react-query';

export function useMeQuery(options?: UseMeQueryOptions) {
	return useQuery({
		queryKey: coreApiQueryKey(endpoints.authentication.me),
		queryFn: async () => {
			if (localStorage.getItem(AUTH_LOCAL_STORAGE_KEY) === null) return null;

			return coreApiClient.get<{ user: UserMeModel }>(
				endpoints.authentication.me
			);
		},
		select: (response) => (response ? response.data.user : null),
		staleTime: Infinity,
		...options,
	});
}

type UseMeQueryOptions = UseQueryOptions<
	AxiosResponse<{ user: UserMeModel }> | null,
	AxiosError<CoreApiError>,
	UserMeModel | null
>;
